<div class="adx-lib-widget-view-wrapper">
  <div #videoStreamContainer class="adx-video-container">
    <video
      #videoPlayer
      [autoplay]="true"
      [muted]="true"
      crossorigin="anonymous"
      controls
      [id]="widgetId"
      (play)="videoStreamService.onPlay(videoElement?.nativeElement)"
      (pause)="videoStreamService.onPause(videoElement?.nativeElement)"
      [hidden]="streamStatus !== 'available'">
    </video>
    @if (streamStatus === 'stuck') {
      <div class="adx-warning-message">
        <p><fa-icon class="adx-triangle-exclamation-icon-color" [icon]="'triangle-exclamation'"></fa-icon> {{ 'STREAMING.AHOY_VIDEO.WIDGET.STREAM_STUCK' | translate }}</p>
      </div>
    }
    @if (streamStatus === 'notAvailable') {
      <img
        [ngSrc]="'../../../assets/img/no_stream_available.png'"
        priority
        alt="No Stream Available"
        class="noStreamImage"
        width="512"
        height="512">
    }
  </div>
</div>
